import { BASE_URL } from '../../constants/app';

export const createCanonicalUrl = (path: string) => `${BASE_URL}${path}`;
